import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const CategoryListStyled = styled.div`
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
  height: 100%;
  overflow-y: auto;
  padding-bottom: ${({ theme }) => theme.spacings['800']};
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
`;
interface CategoryItemStyledProps {
  isSelected: boolean;
}
export const CategoryItemStyled = styled.div<CategoryItemStyledProps>`
  width: 240px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['200']};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue['100']};
  }
  ${(props) =>
    props.isSelected &&
    css`
      background-color: ${({ theme }) => theme.colors.blue['100']};
    `};
`;

export const ToolCategorySectionHeaderStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
  padding-left: ${({ theme }) => theme.spacings['500']};
  padding-top: ${({ theme }) => theme.spacings['300']};
  padding-bottom: ${({ theme }) => theme.spacings['300']};
  background-color: ${({ theme }) => theme.colors.grey['100']};
`;

export const ToolCategoryIcon = styled.i`
  ${({ theme }) => css`
    color: ${theme.colors.blue[800]};
    font-size: ${theme.fontSizes[800]};
  `}
`;
export const NonCatalogItemStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
})`
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
  background-color: ${({ theme }) => theme.colors.purple['100']};
  border-top: 1px solid ${({ theme }) => theme.colors.grey['200']};
  width: 239px;
  height: 35px;
  padding: 11px;
  text-decoration: underline;
  cursor: pointer;
`;
